import React from 'react';
import { connect } from 'react-redux';
import { Grid, Paper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import cardList from './cardList';
import useStyles from '../../../assets/jss/dashboardSection-styles';

const AdditionalActions = (props) => {
  const { auth } = props;

  const classes = useStyles(props)();

  return !cardList(props.auth).length ? null : (
    <Grid item xs={12}>
      <Paper className={classes.sectionWrapper} elevation={0}>
        <Typography component='h2' variant='h6' className={classes.sectionLabel} fontWeight='fontWeightMedium'>
          {'Additional Actions'}
        </Typography>
        <Grid container spacing={3}>
          {cardList(auth)}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default connect((state) => state)(AdditionalActions);
